import React from 'react';
import { ArrowButtonSides } from '../../Interfaces/componentTypes';
import { LeftActive, LeftDisable, RightActive, RightDisable } from '../../Assets/Images';
import styles from './arrowBotton.module.scss';

const ARROW_ICONS = {

    [ArrowButtonSides.Left]: {
        disable: LeftDisable,
        active: LeftActive
    },
    [ArrowButtonSides.Right]: {
        disable: RightDisable,
        active: RightActive
    },
}
interface IProps {
    type?: 'submit' | 'reset' | 'button' | undefined;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    direction: ArrowButtonSides,
    disable?: boolean
};

const ArrowButton: React.FC<IProps> = (props) => {
    const { type, onClick, direction, disable = false } = props;
    return (
        <div className={styles.container}>
            <button
                type={type}
                onClick={onClick}
                disabled={disable}
                className={styles.button}
            >
                    <img
                    className={styles.img}
                    style={!disable ? {cursor:"pointer"} : undefined}
                    src={
                        disable
                        ?
                        ARROW_ICONS[direction].disable
                        :
                        ARROW_ICONS[direction].active
                    }
                    alt={`${direction}.icon`}
                    />
            </button>

        </div>
    )
}

export default ArrowButton
